__turbopack_context__.v({
  "leftColumn": "styles-module-scss-module__r9RsTq__leftColumn",
  "mobileImage": "styles-module-scss-module__r9RsTq__mobileImage",
  "rightColumn": "styles-module-scss-module__r9RsTq__rightColumn",
});
